import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { environment } from '@env/environment';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
declare var $:any;
interface list {
  id?: number;
  platform_group_type_id: string,
  platform_group_type_code_system: string,
  platform_group_type_code_manual: string,
  platform_group_type_title_en: string,
  platform_group_type_title_ar: string
}
@Component({
  selector: 'app-wtypes',
  templateUrl: './wtypes.component.html',
  styleUrls: ['./wtypes.component.scss']
})
export class WtypesComponent implements OnInit {
  modalRefA: BsModalRef;
  tabledatas: list[];
  form:FormGroup;
  @Output() actionEvent             = new EventEmitter<any>();
  collectionSize                    = 0;
  page                              = 1;
  pageSize                          = 10;
  searchKey                         = "";
  nodata: string                    = this.lang.transform('lang_loading');
  admin                             = JSON.parse(this.ls.getItem('is_admin'));
  wholeData:any                     = [];
  tabledata:any                     = [];
  constructor(public ds:DataService, public lang:LanguagePipe, public ls:LocalStorage, public spinner:PreloaderService, public alert:AlertService, public modalService: BsModalService, public dialog:MatDialog, public fb:FormBuilder) { }
  ngOnInit(): void {
    this.spinner.show();
    this.get_group_types();
    this.form = new FormGroup({
      platform_group_type_id            : new FormControl(''),
      platform_group_type_title_en      : new FormControl('', [Validators.required]),
      platform_group_type_title_ar      : new FormControl('', [Validators.required]),
      platform_group_type_code_manual   : new FormControl(''),
    });
  }
  //add, edit model
  public openModalA(template: TemplateRef<any>) {
    this.modalRefA = this.modalService.show(template, environment.modelconfig);
  }
  public get_group_types() {
    let param = new FormData();
    param.append('search_key', this.searchKey);
    param.append('request', 'list');
    this.ds.getActionByUrl(this.ds.formData2string(param), 'lpgtype').subscribe(res=>{
      this.spinner.hide();
      if(res.status) {
        this.wholeData      = res.records;
        this.tabledatas     = res.records;
        this.collectionSize = res.records.length;
        this.build_table_data();
      } else {
        this.wholeData = [];
        this.nodata = res.error;
      }
    }, error => {
      this.spinner.hide();
      this.wholeData = [];
      this.nodata = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
    }) 
  }
  public build_table_data() {
    this.tabledata = this.tabledatas.map((list, i) => ({ id: i + 1, ...list })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
  public edit_group_type_data(row) {
    this.form.patchValue(row);
  }
  public submit() {
    this.spinner.show();
    if(this.form.get('platform_group_type_id').value) {
      this.ds.putActionByUrl(this.ds.formData2string(this.ds.json2formdata(this.form.value)), 'upgtype/' + this.form.get('platform_group_type_id').value).subscribe(res=> {
        this.spinner.hide();
        if(res.status) {
          this.get_group_types();
          this.form.reset();
          this.actionEvent.emit('');
          this.alert.success(res.msg);
          setTimeout(() => {
            this.modalRefA.hide();
          }, 1000);
        } else {
          this.alert.error(res.error);
        }
      }, error => {
        this.spinner.hide();
        this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
      })
    } else {
      this.ds.postActionByUrl(this.ds.json2formdata(this.form.value), 'cpgtype').subscribe(res=> {
        this.spinner.hide();
        if(res.status) {
          this.get_group_types();
          this.form.reset();
          this.actionEvent.emit('');
          this.alert.success(res.msg);
          setTimeout(() => {
            this.modalRefA.hide();
          }, 1000);
        } else {
          this.alert.error(res.error);
        }
      }, error => {
        this.spinner.hide();
        this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
      })
    }
  }
  public checkallItemsWTyp(event) {
    if (event.target.checked) {
      $(".appwtypes .eachItemWTyp").prop("checked", true);
      $(".appwtypes .makeback").addClass("bground");
      $(".appwtypes .deleteIconDiv").show();
    } else {
      $(".appwtypes .eachItemWTyp").prop("checked", false);
      $(".appwtypes .makeback").removeClass("bground");
      $(".appwtypes .deleteIconDiv").hide();
    }
  }
  public checkeachItemWTyp(event) {
    if (event.target.checked) {
      const val = event.target.value;
      $(".appwtypes .removerow" + val).addClass("bground");
    } else {
      const val = event.target.value;
      $(".appwtypes .removerow" + val).removeClass("bground");
    }
    const checkedtotal = [];
    $(".appwtypes .eachItemWTyp:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    const totalrow = [];
    $(".appwtypes .eachItemWTyp").each(function () {
      totalrow.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      $(".appwtypes .deleteIconDiv").show();
    } else {
      $(".appwtypes .deleteIconDiv").hide();
    }
    if (checkedtotal.length === totalrow.length) {
      $(".appwtypes #allItemsWTyp").prop("checked", true);
    } else {
      $(".appwtypes #allItemsWTyp").prop("checked", false);
    }
  }
  public deleteBulkDataWTyp() {
    const checkedtotal = [];
    $(".appwtypes .eachItemWTyp:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialog,{
        disableClose: true,
        width:'400px',
        data:{
          title: this.lang.transform('lang_confirmation'),
          message: this.lang.transform('lang_are_you_sure'),          
        }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.spinner.show()
          this.ds.deleteActionByUrl(checkedtotal, 'dpgtype').subscribe(
            (data) => {
              this.spinner.hide()
              if (data.status) {
                this.actionEvent.emit('');
                this.get_group_types();
                $(".appwtypes #allItemsWTyp").prop("checked", false);
                $(".appwtypes .deleteIconDiv").hide();
                this.ds.dialogf('', data.msg);
              } else {
                this.ds.dialogf('', data.error);
              }
            },
            (error) => {
              this.ds.dialogf('', (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
              this.spinner.hide()
            }
          );
        }
      });
    } else {
      this.ds.dialogf();
    }
  }
}
